import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "../stores/auth";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/login",
      name: "login",
      component: () => import("../pages/LoginPage.vue"),
      meta: { requiresAuth: false, title: "登录" },
    },
    {
      path: "/",
      component: () => import("../layouts/MainLayout.vue"),
      meta: { requiresAuth: true },
      children: [
        {
          path: "",
          name: "home",
          component: () => import("../pages/HomePage.vue"),
          meta: { title: "首页" },
        },
        {
          path: "customers",
          name: "customers",
          component: () => import("../pages/CustomersPage.vue"),
          meta: { title: "客户管理" },
        },
        {
          path: "customers/:id",
          name: "customer-detail",
          component: () => import("../pages/CustomerDetailPage.vue"),
          meta: { title: "客户详情" },
        },
        {
          path: "customers/:id/ledger",
          name: "customer-ledger",
          component: () => import("../pages/CustomerLedgerPage.vue"),
          meta: { title: "客户往来账" },
        },
        {
          path: "customers/:id/statement",
          name: "customer-statement",
          component: () => import("../pages/CustomerStatementPage.vue"),
          meta: { title: "客户对账" },
        },
        {
          path: "fabrics",
          name: "fabrics",
          component: () => import("../pages/FabricsPage.vue"),
          meta: { title: "布料管理" },
        },
        {
          path: "fabrics/:id",
          name: "fabric-detail",
          component: () => import("../pages/FabricDetailPage.vue"),
          meta: { title: "布料详情" },
        },
        {
          path: "warehouses",
          name: "warehouses",
          component: () => import("../pages/WarehousesPage.vue"),
          meta: { title: "仓库管理" },
        },
        {
          path: "warehouses/:id",
          name: "warehouse-detail",
          component: () => import("../pages/WarehouseDetailPage.vue"),
          meta: { title: "仓库详情" },
        },
        {
          path: "inventory",
          name: "inventory",
          component: () => import("../pages/NotAvailablePage.vue"),
          meta: { title: "库存管理" },
        },
        {
          path: "orders",
          name: "orders",
          component: () => import("../pages/OrdersPage.vue"),
          meta: { title: "发货管理" },
        },
        {
          path: "orders/new",
          name: "order-new",
          component: () => import("../pages/SalesOrderEditPage.vue"),
          meta: { title: "新建发货单" },
        },
        {
          path: "orders/:id",
          name: "order-detail",
          component: () => import("../pages/SalesOrderDetailPage.vue"),
          meta: { title: "发货单详情" },
        },
        {
          path: "orders/:id/edit",
          name: "order-edit",
          component: () => import("../pages/SalesOrderEditPage.vue"),
          meta: { title: "编辑发货单" },
        },
        { path: "purchase-reconciliation", name: "purchase-reconciliation", component: () => import("../pages/PurchaseAnnualPage.vue"), meta: { title: "采购年度汇总" } },
        { path: "suppliers", name: "suppliers", component: () => import("../pages/SuppliersPage.vue"), meta: { title: "厂家与对账" } },
        { path: "suppliers/:id", name: "supplier-detail", component: () => import("../pages/SupplierDetailPage.vue"), meta: { title: "厂家账本与对账" } },
        { path: "purchases", name: "purchases", component: () => import("../pages/PurchasesPage.vue"), meta: { title: "采购收货" } },
        { path: "purchases/:id", name: "purchase-detail", component: () => import("../pages/PurchaseDetailPage.vue"), meta: { title: "采购单详情" } },
        { path: "stock", name: "stock", component: () => import("../pages/StockPage.vue"), meta: { title: "库存与裁剪" } },
        {
          path: "finance",
          name: "finance",
          component: () => import("../pages/FinancePage.vue"),
          meta: { title: "账本管理" },
        },
        {path:"settings/inventory",name:"inventory-settings",component:()=>import("../pages/InventorySettingsPage.vue"),meta:{title:"库存启用设置"}},
        {
          path: "settings/accounting",
          name: "accounting-settings",
          component: () => import("../pages/AccountingSettingsPage.vue"),
          meta: { title: "账务设置" },
        },
        {
          path: "settings/password",
          name: "change-password",
          component: () => import("../pages/ChangePasswordPage.vue"),
          meta: { title: "修改密码" },
        },
      ],
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/",
    },
  ],
});

router.beforeEach(async (to) => {
  const authStore = useAuthStore();

  if (to.meta.requiresAuth !== false) {
    if (!authStore.isAuthenticated) {
      const ok = await authStore.fetchSession();
      if (!ok) {
        return { name: "login", query: { redirect: to.fullPath } };
      }
    }
  }

  if (to.name === "login" && authStore.isAuthenticated) {
    return { name: "home" };
  }
});

router.afterEach((to) => {
  const title = to.meta.title as string | undefined;
  document.title = title ? title + " - 布序" : "布序";
});

export default router;
